import {
  CategoryBaseInfo,
  CategoryBreadcrumbs,
} from '@/api/types/categories.types';
import { Breadcrumb } from '@/components/Breadcrumbs/Breadcrumbs.types';

function handleParent(
  category: CategoryBreadcrumbs | CategoryBaseInfo,
  breadcrumbs: Breadcrumb[],
  linkSuffix?: string
) {
  if (category.parent) {
    const link = `/${category.parent.path}`.concat(linkSuffix ?? '');
    breadcrumbs.unshift({ label: category.parent.name, link });

    handleParent(category.parent, breadcrumbs, linkSuffix);
  }
}

export function buildBreadcrumbs(
  category?: CategoryBreadcrumbs | CategoryBaseInfo | null,
  linkSuffix?: string
): Breadcrumb[] {
  if (!category) return [];

  const breadcrumbs = [];

  breadcrumbs.push({
    label: category.name,
    link: `/${category.path}`.concat(linkSuffix ?? ''),
  });

  handleParent(category, breadcrumbs, linkSuffix);

  return breadcrumbs;
}
